import { AlertTitle, Alert as MuiAlert } from '@mui/material';
import type { AlertProps as MuiAlertProps } from '@mui/material';
import React from 'react';

interface AlertProps extends MuiAlertProps {
  title?: string;
  children?: React.ReactNode;
}

export default function Alert(props: AlertProps) {
  const { children, title, ...restProps } = props;

  return (
    <MuiAlert severity="error" {...restProps}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </MuiAlert>
  );
}
